<template>
  <div>
    <section class="page">
      <b-container>
        <b-row>
          <h2>Erreichte Meilensteine</h2>
        </b-row>
        <b-row>
          <div
            class="col-sm-12 col-md-12 col-lg-6 story filter-sentence-container "
          >
            <div class="filter-sentence ">
              <p>
                Zeige mir alle Meilensteine<br />
                <select class="select-dropdown" v-model="status">
                  <option :value="null">in allen Phasen</option>
                  <option value="planning">in der Planungsphase</option>
                  <option value="design">in der Konzeptionsphase</option>
                  <option value="implementation">in der Umsetzungsphase</option>
                  <option value="done">zur Fertigstellung</option> </select
                ><br />
                die im gewählten Zeitraum erreicht wurden.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 visual">
            <ul
              class="list-group list-group-flush scrolling-list"
              v-if="allOzgTimelineItems"
            >
              <li
                class="list-group-item"
                v-for="event in allOzgTimelineItems.edges"
                v-bind:key="event.id"
              >
                {{ event.node.service.name }}
                <OZGLevelEmoji
                  :level="event.node.service.implementationLevel"
                />
                <br />
                <b
                  >{{ moment(event.node.start).format("DD.MM.YYYY") }} -
                  {{ event.node.status.event }}
                  <OZGLevelEmoji :marked-as-done="event.node.markedAsDone" :marked-as-started="event.node.markedAsStarted"></OZGLevelEmoji>
                </b>
              </li>
            </ul>
          </div>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import OZGLevelEmoji from "./../OZGLevelEmoji";

export default {
  name: "WeeklyAchievedMilestones",
  props: ["start", "end"],
  data() {
    return {
      allOzgTimelineItems: [],
      status: null
    };
  },
  components: { OZGLevelEmoji },

  apollo: {
    $client: "ozgClient",

    allOzgTimelineItems: {
      query() {
        return require("../../graphql/weeklyAchivedMilestones.gql");
      },
      variables: function() {
        return {
          start: this.$props.start,
          end: this.$props.end,
          status: this.status
        };
      }
    }
  }
};
</script>

<style scoped></style>

<style scoped lang="scss">
.scrolling-list {
  max-height: 600px;
  overflow-y: scroll;
  padding-bottom: 30px;
}

.scrolling-list::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.scrolling-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #111111;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.9);
}

.vbt-autcomplete-list {
  border-radius: 0px;

  .list-group-item:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
  .list-group-item:last-child {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}
.interactive-title {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  font-style: italic;
}

.black {
  border: #111111 solid 2px !important;
}

.list-group-flush > .list-group-item {
  padding-left: 0;
}
.filter-sentence-container {
}
.filter-sentence {
  margin-top: 2vh;
}
.loading-anim {
  margin-top: 8vh;
}

.filter-sentence .select-dropdown {
  background-color: #fff;
  background-image: none;
  padding: 6px;
  font-size: 1.5rem;
  line-height: 2rem;

  @media (max-width: 576px) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  text-align: center;
  font-family: "Open Sans Condensed", sans-serif;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 10px;
  border-radius: 1px;
  outline: 2px inset black;
  outline-offset: -2px;
}

.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #000;
}
.select-css:focus {
  border-color: #000;
  box-shadow: none;
  color: #222;
  outline: none;
}
</style>
